/* eslint-disable */
var Toast = {};
var showToast = false, // 存储toast显示状态
    showLoad = false, // 存储loading显示状态
    toastVM = null, // 存储toast vm
    loadNode = null; // 存储loading节点元素
var optInit = function (opt, options) {
    for (var property in options) {
        opt[property] = options[property];
    }
}
Toast.install = function (Vue, options) {
    Vue.prototype.$toast = function (tips, type) {
        var opt = {
            word: '',
            defaultType: 'bottom',
            duration: '2500',
            wordWrap: false,
            backgroundColor: 'rgba(0, 0, 0, 0.7)'
        };
        optInit(opt, tips)
        var curType = type? type: opt.defaultType;
        var wordWrap = opt.wordWrap? 'lx-word-wrap': '';
        var style = `v-bind:style="styleObject"`
        var tmp = '<div v-show="show" :class="type" class="lx-toast ' + wordWrap + '" ' + style + '>{{tip}}</div>';
        if (showToast) {
            return;
        }
        if (!toastVM) {
            var toastTpl = Vue.extend({
                data: function () {
                    return {
                        show: showToast,
                        tip: tips.word ? tips.word: tips,
                        type: 'lx-toast-' + curType,
                        styleObject: {
                            width: tips.width ? tips.width:opt.width,
                            backgroundColor: tips.backgroundColor ? tips.backgroundColor : opt.backgroundColor,
                            top: tips.top ? tips.top : '',
                            bottom: tips.bottom ? tips.bottom : '',
                            'z-index': 99999
                        }
                    }
                },
                template: tmp
            });
            toastVM = new toastTpl()
            var tpl = toastVM.$mount().$el;
            document.body.appendChild(tpl);
        }
        toastVM.type = 'lx-toast-' + curType;
        toastVM.styleObject = {
            width: tips.width ? tips.width : opt.width,
            backgroundColor: tips.backgroundColor ? tips.backgroundColor : opt.backgroundColor,
            top: tips.top ? tips.top : '',
            bottom: tips.bottom ? tips.bottom : ''
        }
        toastVM.tip = tips.word;
        toastVM.show = showToast = true;

        setTimeout(function () {
            toastVM.show = showToast = false;
        }, opt.duration)
    };
    ['bottom', 'center', 'top'].forEach(function (type) {
        Vue.prototype.$toast[type] = function (tips) {
            return Vue.prototype.$toast(tips, type)
        }
    });

    Vue.prototype.$loading = function (tips, type) {
        if (type == 'close') {
            loadNode.show = showLoad = false;
            var markNode = document.querySelector('.lx-load-mark');
            if (markNode) 
                markNode.remove();
        } else {
            if (showLoad) {
                return;
            }
            var loadTpl = Vue.extend({
                data: function () {
                    return {
                        show: showLoad,
                        initDefault: tips.initDefault,
                        styleObject: {
                            backgroundColor: tips.backgroundColor ? tips.backgroundColor : '',
                            backgroundImage: tips.backgroundImg ? tips.backgroundImg : '',
                            word: tips.word ? tips.word : '',
                            width: tips.containW ? tips.containW : '',
                            top: tips.containT ? tips.containT : '',
                            left: tips.containL ? tips.containL : '',
                            marginLeft: tips.marginLeft ? tips.marginLeft : '',
                            'z-index': 99999
                        },
                        lodingSrc: tips.lodingSrc ? tips.lodingSrc : '', 
                        loadingStyle: {
                          width: tips.loadingW ? tips.loadingW : '',
                          height: tips.loadingH ? tips.loadingH : '',
                          margin: tips.distance ? tips.distance : ''
                        }
                    }
                },
                template:   `<div v-show="show" class="lx-load-mark">
                                <div class="lx-load-box" v-bind:style="styleObject">
                                    <div v-bind:class="[ initDefault ? 'lx-loading' : '']">
                                        <img :src="lodingSrc" v-bind:style="loadingStyle" class="loadingGif" v-show="!initDefault"/>
                                        <div class="loading_leaf loading_leaf_0" v-show="initDefault"></div>
                                        <div class="loading_leaf loading_leaf_1" v-show="initDefault"></div>
                                        <div class="loading_leaf loading_leaf_2" v-show="initDefault"></div>
                                        <div class="loading_leaf loading_leaf_3" v-show="initDefault"></div>
                                        <div class="loading_leaf loading_leaf_4" v-show="initDefault"></div>
                                        <div class="loading_leaf loading_leaf_5" v-show="initDefault"></div>
                                        <div class="loading_leaf loading_leaf_6" v-show="initDefault"></div>
                                        <div class="loading_leaf loading_leaf_7" v-show="initDefault"></div>
                                        <div class="loading_leaf loading_leaf_8" v-show="initDefault"></div>
                                        <div class="loading_leaf loading_leaf_9" v-show="initDefault"></div>
                                        <div class="loading_leaf loading_leaf_10" v-show="initDefault"></div>
                                        <div class="loading_leaf loading_leaf_11" v-show="initDefault"></div>
                                    </div>
                                    <div v-bind:class="[ initDefault ? 'word-top' : '', 'lx-load-content']">{{styleObject.word}}</div>
                                </div>
                            </div>`
            });
            loadNode = new loadTpl();
            var tpl = loadNode.$mount().$el;
            document.body.appendChild(tpl);
            loadNode.show = showLoad = true;
        }
    };

    ['open', 'close'].forEach(function (type) {
        console.log(type)
        Vue.prototype.$loading[type] = function (tips) {
            return Vue.prototype.$loading(tips, type)
        }
    });
}
module.exports = Toast;
